// ziven-post-comment forum webpack entry
// flarum-webpack-config looks for forum.{js,ts} in process.cwd() (which is
// the `js/` directory at build time).

import './src/forum/index.js';

export default {};
